import { render, staticRenderFns } from "./EditMyLists.vue?vue&type=template&id=2b49ff0e&"
import script from "./EditMyLists.vue?vue&type=script&lang=js&"
export * from "./EditMyLists.vue?vue&type=script&lang=js&"
import style0 from "./EditMyLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports